export default "/_next/static/videos/pleo-showreel-short_compressed.mp4";